<template>
  <Draggable
    :id="id"
    :tag="tag"
  >
    <slot />
  </Draggable>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Draggable } from 'vue-smooth-dnd';

export default defineComponent({
  name: 'RsDragger',
  components: {
    Draggable,
  },
  props: {
    tag: {
      type: [Object, String],
      default: 'div',
    },
    id: {
      type: [Number, String],
      default: '',
    },
  },
});
</script>

<style lang="scss" scoped>
  @import '@/styles/_variables.scss';

</style>
